// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class RegexPattern {
  /// <summary>
  /// Regular Expression to determine if a string contains only letters
  /// </summary>
  static ALPHA = /[^a-zA-Z]/;
  /// <summary>
  /// Regular Expression to determine if a string contains letters and numbers
  /// </summary>
  static ALPHA_NUMERIC = /[^a-zA-Z0-9]/;
  /// <summary>
  /// Regular Expression to determine if a string contains letters, numbers and whitespace
  /// </summary>
  static ALPHA_NUMERIC_SPACE = /[^a-zA-Z0-9\s]/;
  /// <summary>
  /// Regular Expression to determine if a string is properly formatted as an American Express credit card number
  /// </summary>
  static CREDIT_CARD_AMERICAN_EXPRESS = /^(?:(?:[3][4|7])(?:\d{13}))$/;
  /// <summary>
  /// Regular Expression to determine if a string is properly formatted as a Carte Blanche credit card number
  /// </summary>
  static CREDIT_CARD_CARTE_BLANCHE = /^(?:(?:[3](?:[0][0-5]|[6|8]))(?:\d{11,12}))$/;
  /// <summary>
  /// Regular Expression to determine if a string is properly formatted as a Diners Club credit card number
  /// </summary>
  static CREDIT_CARD_DINERS_CLUB = /^(?:(?:[3](?:[0][0-5]|[6|8]))(?:\d{11,12}))$/;
  /// <summary>
  /// Regular Expression to determine if a string is properly formatted as a Discover credit card number
  /// </summary>
  static CREDIT_CARD_DISCOVER = /^(?:(?:6011)(?:\d{12}))$/;
  /// <summary>
  /// Regular Expression to determine if a string is properly formatted as an En Route credit card number
  /// </summary>
  static CREDIT_CARD_EN_ROUTE = /^(?:(?:[2](?:014|149))(?:\d{11}))$/;
  /// <summary>
  /// Regular Expression to determine if a string is properly formatted as a JCB credit card number
  /// </summary>
  static CREDIT_CARD_JCB = /^(?:(?:(?:2131|1800)(?:\d{11}))$|^(?:(?:3)(?:\d{15})))$/;
  /// <summary>
  /// Regular Expression to determine if a string is properly formatted as a MasterCard credit card number
  /// </summary>
  static CREDIT_CARD_MASTER_CARD = /^(?:(?:[5][1-5])(?:\d{14}))$/;
  /// <summary>
  /// Regular Expression to determine if a string is formatted as non-numeric credit card strip data
  /// </summary>
  static CREDIT_CARD_STRIP_NON_NUMERIC = /(-|\s|\D)*/;
  /// <summary>
  /// Regular Expression to determine if a string is properly formatted as a Visa credit card number
  /// </summary>
  static CREDIT_CARD_VISA = /^(?:(?:[4])(?:\d{12}|\d{15}))$/;
  /// <summary>
  /// Regular Expression to determine if a string is a properly formatted e-mail address
  /// </summary>
  static EMAIL = /^([0-9a-zA-Z]+[-._+&])*[0-9a-zA-Z]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,6}$/;
  /// <summary>
  /// Regular Expression to determine if a string is properly formatted as a GUID
  /// </summary>
  static GUID = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;
  /// <summary>
  /// Regular Expression to determine if a string is properly formatted as a IP Address
  /// </summary>
  static IP_ADDRESS = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  /// <summary>
  /// Regular Expression to determine if a string is all lower case
  /// </summary>
  static LOWER_CASE = /^[a-z]+$/;
  /// <summary>
  /// Regular Expression to determine if a string is numeric
  /// </summary>
  static NUMERIC = /[^0-9]/;
  /// <summary>
  /// Regular Expression to determine if a string is a properly formatted Social Security Number (xxx-xx-xxxx)
  /// </summary>
  static SOCIAL_SECURITY = /^\d{3}[-]?\d{2}[-]?\d{4}$/;
  /// <summary>
  /// Regular Expression to determine if a string could be used as a strong password
  /// </summary>
  static STRONG_PASSWORD =
    /(?=^.{8,255}$)((?=.*d)(?=.*[A-Z])(?=.*[a-z])|(?=.*d)(?=.*[^A-Za-z0-9])(?=.*[a-z])|(?=.*[^A-Za-z0-9])(?=.*[A-Z])(?=.*[a-z])|(?=.*d)(?=.*[A-Z])(?=.*[^A-Za-z0-9]))^.*/;

  /// <summary>
  /// Regular Expression to determine if a string is all upper case
  /// </summary>
  static UPPER_CASE = /^[A-Z]+$/;
  /// <summary>
  /// Regular Expression to determine if a string is a properly formatted URL
  /// </summary>
  static URL = /^(ht|f)tp(s?):\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-.?,'/\\+&%$#_=]*)?$/;
  /// <summary>
  /// Regular Expression to determine if a string is a properly formatted as US Currency
  /// </summary>
  static US_CURRENCY = /^$(([1-9]d*|([1-9]\d{0,2}(,\d{3})*))(.\d{1,2})?|(.\d{1,2}))$|^$[0](.00)?$/;
  /// <summary>
  /// Regular Expression to determine if a string is a properly formatted US Telephone Number
  /// </summary>
  static US_TELEPHONE = /^[01]?[- .]?(([2-9]\d{2})|[2-9]\d{2})[- .]?\d{3}[- .]?\d{4}$/;
  /// <summary>
  /// Regular Expression to determine if a string is a properly formatted US Zip Code (5 character only)
  /// </summary>
  static US_ZIPCODE = /^\d{5}$/;
  /// <summary>
  /// Regular Expression to determine if a string is a properly formatted US Zip Code + 4
  /// </summary>
  static US_ZIPCODE_PLUS_FOUR = /^\d{5}((-|s)?\d{4})$/;
  /// <summary>
  /// Regular Expression to determine if a string is a properly formatted US Zip Code + Optional 4
  /// </summary>
  static US_ZIPCODE_PLUS_FOUR_OPTIONAL = /^\d{5}((-|s)?\d{4})?$/;
  /// <summary>
  /// Regular Expression to determine if a string is a Med Category ID (Benefit ID Reference)
  /// </summary>
  static MED_CATEGORY_ID = /^<<MedCategoryID=(\d+?)>>$/;
  /// <summary>
  /// Regular Expression to determine if a string is a properly formatted US phone number. Example: (###) ###-####
  /// </summary>
  static US_FORMATTED_PHONE_NUMBER = /^\([2-9]\d{2}\)[ ]\d{3}[-]\d{4}$/;

  /// <summary>
  /// Regular Expression to determine if a string is a Medicare number
  /// </summary>
  static MBI_PATTERN =
    /^[1-9][AC-HJKMNP-RT-Yac-hjkmnp-rt-y][AC-HJKMNP-RT-Yac-hjkmnp-rt-y0-9][0-9][AC-HJKMNP-RT-Yac-hjkmnp-rt-y][AC-HJKMNP-RT-Yac-hjkmnp-rt-y0-9][0-9][AC-HJKMNP-RT-Yac-hjkmnp-rt-y]{2}[0-9]{2}$/;
}
